import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dNonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
const $ConditionMode = tag => tag;
const AtLeast = /* #__PURE__ */ $ConditionMode("AtLeast");
const JustDraw = /* #__PURE__ */ $ConditionMode("JustDraw");
const Remains = /* #__PURE__ */ $ConditionMode("Remains");
const JustRemains = /* #__PURE__ */ $ConditionMode("JustRemains");
const Choice = /* #__PURE__ */ $ConditionMode("Choice");
const LeftOne = /* #__PURE__ */ $ConditionMode("LeftOne");
const LeftAll = /* #__PURE__ */ $ConditionMode("LeftAll");
const genericConditionMode_ = {
  to: x => {
    if (x.tag === "Inl") { return AtLeast; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return JustDraw; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Remains; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return JustRemains; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return Choice; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return LeftOne; }
              if (x._1._1._1._1._1.tag === "Inr") { return LeftAll; }
            }
          }
        }
      }
    }
    $runtime.fail();
  },
  from: x => {
    if (x === "AtLeast") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x === "JustDraw") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x === "Remains") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x === "JustRemains") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x === "Choice") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x === "LeftOne") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x === "LeftAll") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    $runtime.fail();
  }
};
const showConditionMode = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AtLeast"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "JustDraw"});
    const $2 = (() => {
      const $2 = (() => {
        const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Remains"});
        const $3 = (() => {
          const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "JustRemains"});
          const $4 = (() => {
            const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Choice"});
            const $5 = (() => {
              const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "LeftOne"});
              const $6 = (() => {
                const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "LeftAll"});
                return {
                  "genericShow'": v => {
                    if (v.tag === "Inl") { return $5["genericShow'"](v._1); }
                    if (v.tag === "Inr") { return $6["genericShow'"](v._1); }
                    $runtime.fail();
                  }
                };
              })();
              return {
                "genericShow'": v => {
                  if (v.tag === "Inl") { return $4["genericShow'"](v._1); }
                  if (v.tag === "Inr") { return $6["genericShow'"](v._1); }
                  $runtime.fail();
                }
              };
            })();
            return {
              "genericShow'": v => {
                if (v.tag === "Inl") { return $3["genericShow'"](v._1); }
                if (v.tag === "Inr") { return $5["genericShow'"](v._1); }
                $runtime.fail();
              }
            };
          })();
          return {
            "genericShow'": v => {
              if (v.tag === "Inl") { return $2["genericShow'"](v._1); }
              if (v.tag === "Inr") { return $4["genericShow'"](v._1); }
              $runtime.fail();
            }
          };
        })();
        return {
          "genericShow'": v => {
            if (v.tag === "Inl") { return $1["genericShow'"](v._1); }
            if (v.tag === "Inr") { return $3["genericShow'"](v._1); }
            $runtime.fail();
          }
        };
      })();
      return {
        "genericShow'": v => {
          if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
          if (v.tag === "Inr") { return $2["genericShow'"](v._1); }
          $runtime.fail();
        }
      };
    })();
    return x => $2["genericShow'"]((() => {
      if (x === "AtLeast") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
      if (x === "JustDraw") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
      if (x === "Remains") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
      if (x === "JustRemains") {
        return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
      }
      if (x === "Choice") {
        return Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        );
      }
      if (x === "LeftOne") {
        return Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        );
      }
      if (x === "LeftAll") {
        return Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
          )
        );
      }
      $runtime.fail();
    })());
  })()
};
const eqConditionMode = {
  eq: x => y => {
    if (x === "AtLeast") { return y === "AtLeast"; }
    if (x === "JustDraw") { return y === "JustDraw"; }
    if (x === "Remains") { return y === "Remains"; }
    if (x === "JustRemains") { return y === "JustRemains"; }
    if (x === "Choice") { return y === "Choice"; }
    if (x === "LeftOne") { return y === "LeftOne"; }
    return x === "LeftAll" && y === "LeftAll";
  }
};
const ordConditionMode = {
  compare: x => y => {
    if (x === "AtLeast") {
      if (y === "AtLeast") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "AtLeast") { return Data$dOrdering.GT; }
    if (x === "JustDraw") {
      if (y === "JustDraw") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "JustDraw") { return Data$dOrdering.GT; }
    if (x === "Remains") {
      if (y === "Remains") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "Remains") { return Data$dOrdering.GT; }
    if (x === "JustRemains") {
      if (y === "JustRemains") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "JustRemains") { return Data$dOrdering.GT; }
    if (x === "Choice") {
      if (y === "Choice") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "Choice") { return Data$dOrdering.GT; }
    if (x === "LeftOne") {
      if (y === "LeftOne") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "LeftOne") { return Data$dOrdering.GT; }
    if (x === "LeftAll" && y === "LeftAll") { return Data$dOrdering.EQ; }
    $runtime.fail();
  },
  Eq0: () => eqConditionMode
};
const toConditionGroup = /* #__PURE__ */ (() => {
  const $0 = Data$dArray$dNonEmpty.filter(a => !a.disabled);
  const $1 = Data$dFunctor.arrayMap(v => v.condition);
  return x => {
    const $2 = $1(Data$dArray.sortWith(Data$dUUID.ordUUID)(v => v.id)($0(x)));
    if ($2.length > 0) { return Data$dMaybe.$Maybe("Just", $2); }
    return Data$dMaybe.Nothing;
  };
})();
const toConditionSet = /* #__PURE__ */ (() => {
  const $0 = Data$dArray.filter(a => !a.disabled);
  const $1 = Data$dArray.mapMaybe(x => toConditionGroup(x.conditions));
  return x => $1(Data$dArray.sortWith(Data$dUUID.ordUUID)(v => v.id)($0(x)));
})();
const readConditionMode = v => {
  if (v === "AtLeast") { return Data$dMaybe.$Maybe("Just", AtLeast); }
  if (v === "JustDraw") { return Data$dMaybe.$Maybe("Just", JustDraw); }
  if (v === "Remains") { return Data$dMaybe.$Maybe("Just", Remains); }
  if (v === "JustRemains") { return Data$dMaybe.$Maybe("Just", JustRemains); }
  if (v === "Choice") { return Data$dMaybe.$Maybe("Just", Choice); }
  if (v === "LeftOne") { return Data$dMaybe.$Maybe("Just", LeftOne); }
  if (v === "LeftAll") { return Data$dMaybe.$Maybe("Just", LeftAll); }
  return Data$dMaybe.Nothing;
};
const filterCards = x => Data$dArray.filter(a => {
  const $0 = a.id;
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare($0)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go(x);
});
export {
  $ConditionMode,
  AtLeast,
  Choice,
  JustDraw,
  JustRemains,
  LeftAll,
  LeftOne,
  Remains,
  eqConditionMode,
  filterCards,
  genericConditionMode_,
  ordConditionMode,
  readConditionMode,
  showConditionMode,
  toConditionGroup,
  toConditionSet
};
